import * as React from 'react';

const CreditCardFrontSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="credit-card-front_svg__eds-icon--credit-card-front_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="credit-card-front_svg__eds-icon--credit-card-front_base"
            d="M3 6h18v12H3V6zM2 19h20V5H2v14z"
        />
        <g id="credit-card-front_svg__eds-icon--credit-card-front_dashes">
            <path d="M5 15h2v1H5zM9 15h2v1H9zM13 15h2v1h-2zM17 15h2v1h-2z" />
        </g>
        <path
            id="credit-card-front_svg__eds-icon--credit-card-front_square"
            d="M5 12v-2h2v2z"
        />
    </svg>
);

CreditCardFrontSvg.displayName = 'CreditCardFrontSvg';
export default CreditCardFrontSvg;
